var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "featured-designer featured-designer__container" },
    [
      _c(
        "div",
        {
          staticClass: "container",
          class: _vm.featuredDesigner.bgColor,
          style: _vm.paddingStyles
        },
        [
          _c("div", { staticClass: "featured-designer__details" }, [
            _c(
              "div",
              { staticClass: "featured-designer__text" },
              [
                _c(
                  "h2",
                  { class: _vm.featuredDesigner.designerDetails.nameColor },
                  [_vm._v(_vm._s(_vm.featuredDesigner.designerDetails.name))]
                ),
                _c(
                  "p",
                  {
                    staticClass:
                      "featured-designer__details-excerpt u-hidden-mobile-only",
                    class: _vm.featuredDesigner.designerDetails.excerptColor
                  },
                  [_vm._v(_vm._s(_vm.featuredDesigner.designerDetails.excerpt))]
                ),
                _vm.featuredDesigner.enableCta
                  ? _c("div", {
                      staticClass:
                        "featured-designer__view-all-button-container"
                    })
                  : _vm._e(),
                _vm.featuredDesigner.enableCta
                  ? _c(
                      "v-button",
                      {
                        staticClass: "featured-designer__view-all-button",
                        class: _vm.featuredDesigner.ctaLayout,
                        style: { color: "" + _vm.featuredDesigner.ctaColor },
                        attrs: { href: _vm.featuredDesigner.ctaLink, tag: "a" }
                      },
                      [
                        _vm._v(_vm._s(_vm.featuredDesigner.ctaText) + " "),
                        _c("icon", {
                          attrs: {
                            "fill-class": _vm.featuredDesigner.ctaIconColor,
                            name: "arrow-right",
                            size: "14px"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c("p"),
                _vm.featuredDesigner.designerDetails.underlayOpacity > 0
                  ? _c("div", {
                      staticClass: "featured-designer__underlay",
                      class: _vm.featuredDesigner.designerDetails.underlayColor,
                      style: {
                        opacity:
                          _vm.featuredDesigner.designerDetails.underlayOpacity +
                          "%"
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c("div", {
              staticClass: "featured-designer__inner-image",
              class: {
                "featured-designer__inner-image-desktop":
                  _vm.featuredDesigner.designerDetails.imageMobile != null
              },
              style: {
                "background-image":
                  "url(" + _vm.featuredDesigner.designerDetails.image + ")"
              }
            }),
            _vm.featuredDesigner.designerDetails.imageMobile != null
              ? _c("div", {
                  staticClass:
                    "featured-designer__inner-image featured-designer__inner-image-mobile",
                  style: {
                    "background-image":
                      "url(" +
                      _vm.featuredDesigner.designerDetails.imageMobile +
                      ")"
                  }
                })
              : _vm._e()
          ]),
          _c("div", { staticClass: "featured-designer__products-container" }, [
            _c("div", { staticClass: "featured-designer__products" }, [
              _c("div", { staticClass: "featured-designer__header" }, [
                _c("h3", { class: _vm.featuredDesigner.headingColor }, [
                  _vm._v(_vm._s(_vm.featuredDesigner.heading))
                ]),
                _c("div", { staticClass: "controls-container" }, [
                  _c("div", { staticClass: "arrows" }, [
                    _c(
                      "div",
                      {
                        staticClass: "arrow arrow-prev",
                        on: { click: _vm.slidePrev }
                      },
                      [
                        _c("icon", {
                          attrs: {
                            "fill-class": _vm.featuredDesigner.arrowColor,
                            name: "chevron-left",
                            size: "14px"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "arrow arrow-next",
                        on: { click: _vm.slideNext }
                      },
                      [
                        _c("icon", {
                          attrs: {
                            "fill-class": _vm.featuredDesigner.arrowColor,
                            name: "chevron-right",
                            size: "14px"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ]),
              _c(
                "div",
                {
                  staticClass: "featured-designer__carousel",
                  class: { "featured-collection__carousel--hover": _vm.hovered }
                },
                [
                  _c(
                    "swiper",
                    {
                      ref: "productImageCarousel",
                      class: { "swiper-no-swiping": !_vm.shouldSwipe },
                      attrs: { options: _vm.carouselOptions }
                    },
                    _vm._l(
                      _vm.filterProducts(_vm.featuredDesigner.products),
                      function(product, index) {
                        return _c("swiper-slide", { key: "product-" + index }, [
                          _c(
                            "div",
                            {
                              on: {
                                mouseover: function($event) {
                                  _vm.hovered = true
                                },
                                mouseleave: function($event) {
                                  _vm.hovered = false
                                }
                              }
                            },
                            [
                              _c("product-tile", {
                                attrs: {
                                  simple: _vm.isSimpleProductTile,
                                  product: product,
                                  onAddToCart: _vm.addToCart,
                                  showMobileATC: _vm.showMobileATC,
                                  "collection-template": _vm.collectionTemplate,
                                  "text-alignment":
                                    _vm.productTileTextAlignment,
                                  "enable-simple-tile-cta":
                                    _vm.enableSimpleTileCta
                                }
                              })
                            ],
                            1
                          )
                        ])
                      }
                    ),
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }